document.addEventListener('DOMContentLoaded', () => {
  const submenuTriggers = document.querySelectorAll('[data-open-submenu]');
  const submenuGroups = document.querySelectorAll('.header__SubmenuGroup[data-id]');

  if (!submenuTriggers.length || !submenuGroups.length) return;

  const closeSubmenu = submenuId => {
    const submenuGroup = document.querySelector(`.header__SubmenuGroup[data-id="${submenuId}"]`);
    const submenuTrigger = document.querySelector(`[data-open-submenu="${submenuId}"]`);

    submenuGroup?.classList.remove('header__SubmenuGroup--Active');
    submenuGroup?.setAttribute('aria-hidden', 'true');
    submenuTrigger?.setAttribute('aria-expanded', 'false');
  };

  const openSubmenu = submenuId => {
    const submenuGroup = document.querySelector(`.header__SubmenuGroup[data-id="${submenuId}"]`);
    const submenuTrigger = document.querySelector(`[data-open-submenu="${submenuId}"]`);

    if (!submenuGroup || !submenuTrigger) return;

    submenuGroups.forEach(group => {
      if (group.dataset.id !== submenuId) {
        closeSubmenu(group.dataset.id);
      }
    });

    submenuGroup.classList.add('header__SubmenuGroup--Active');
    submenuGroup.setAttribute('aria-hidden', 'false');
    submenuTrigger.setAttribute('aria-expanded', 'true');
  };

  submenuTriggers.forEach(trigger => {
    trigger.addEventListener('click', event => {
      event.preventDefault();

      const submenuId = trigger.getAttribute('data-open-submenu');

      if (!submenuId) return;

      const submenuGroup = document.querySelector(`.header__SubmenuGroup[data-id="${submenuId}"]`);
      const isActive = submenuGroup?.classList.contains('header__SubmenuGroup--Active');

      if (isActive) {
        closeSubmenu(submenuId);
        return;
      }

      openSubmenu(submenuId);
    });
  });

  document.addEventListener('click', event => {
    const clickedTrigger = event.target.closest('[data-open-submenu]');
    const clickedSubmenu = event.target.closest('.header__SubmenuGroup');

    if (clickedTrigger || clickedSubmenu) return;

    submenuGroups.forEach(group => {
      closeSubmenu(group.dataset.id);
    });
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;

    submenuGroups.forEach(group => {
      closeSubmenu(group.dataset.id);
    });
  });
});
